import { render, staticRenderFns } from "./payable-aging.vue?vue&type=template&id=21b1dc1c&scoped=true"
import script from "./payable-aging.vue?vue&type=script&lang=js"
export * from "./payable-aging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1dc1c",
  null
  
)

export default component.exports